import { Config, ConfigMember } from "@/config";

import axios from "axios";

export const Cookie = () => {
  try {
    const data = axios({
      method: "get",
        url: ConfigMember.apiEndpoint + `v1/member/register-terms-policy`,
      headers: {
        Authorization: "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
    });
    return data;
  } catch (error) {
    
  }
};